import { colors } from "components/Theme/WebTheme.js";
import { container, primaryColor } from "./material-kit-react.js";
import { backdropClasses } from "@mui/material";

const footerStyle = {
  block: {
    color: "inherit",
    padding: "0.9375rem",
    fontWeight: "500",
    fontSize: "12px",
    textTransform: "uppercase",
    borderRadius: "3px",
    textDecoration: "none",
    position: "relative",
    display: "block",
  },
  left: {
    float: "left!important",
    display: "block",
  },
  right: {
    margin: "0",
    float: "right!important",
  },
  footer: {
    padding: "0.9375rem 0",
    textAlign: "center",
    display: "flex",
    zIndex: "2",
    position: "relative",
  },
  a: {
    color: primaryColor,
    textDecoration: "none",
    backgroundColor: "transparent",
  },
  footerWhiteFont: {
    "&,&:hover,&:focus": {
      color: colors.WHITE,
    },
  },
  container,
  list: {
    marginBottom: "0",
    padding: "0",
    marginTop: "0",
  },
  inlineBlock: {
    display: "inline-block",
    padding: "0px",
    width: "auto",
  },
  icon: {
    width: "18px",
    height: "18px",
    position: "relative",
    top: "3px",
  },
  spacings: {
    maxWidth: "1440px",
    margin: "0 auto",
    paddingLeft: "20px",
    paddingRight: "20px",
    "@media (min-width: 768px)": {
      paddingLeft: "30px",
      paddingRight: "30px",
    },
    "@media (min-width: 1024px)": {
      paddingLeft: "90px",
      paddingRight: "90px",
    },
    "@media (min-width: 1536px)": {
      paddingLeft: "120px",
      paddingRight: "120px",
    },
  },
  footerContainer: {
    backdropClasses,
    padding: "20px 0px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    fontFamily: "Roboto",
    color: "white",
    gap: "50px",
    "@media (min-width: 1024px)": {
      flexDirection: "row",
      padding: "35px 0px",
    },
  },
  p1FooterContainer: {
    marginBlock: "10px 6px",
    fontSize: "16px",
    maxWidth: "100%",
    fontWeight: "400",
    "@media (min-width: 1024px)": {
      fontSize: "17px",
      maxWidth: "568px",
    },
  },

  footerLogo: {
    width: "93px",
    aspectRatio: "87/22",

    "@media (min-width: 1024px)": {
      width: "150px",
    },

    // marginLeft: "-15px",
  },

  getStartedFooter: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginTop: "-10px",
    paddingTop: "0px",
    cursor: "pointer",
  },

  getThereRelaxedFooter: {
    background:
      "linear-gradient(90deg, #5CAA5A 0%, #70B058 49.52%, #AFCD56 100%)",
    color: "transparent",
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    textFillColor: "transparent",
    WebkitTextFillColor: "transparent",
    fontFamily: "Roboto",
    fontWeight: "500",
    fontSize: "20px",
    lineHeight: "22px",
    letterSpacing: "0%",
  },

  downloadavailabilityBtn: {
    display: "flex",
    gap: "15px",
    cursor: "pointer",
    marginTop: "8px",
  },

  footerSecondSection: {
    display: "flex",
    gap: "20px",
    flexDirection: "column",
    cursor: "pointer",
    padding: "0px 15px",

    "@media (min-width: 1024px)": {
      flexDirection: "row",
      gap: "50px",
      padding: "0px 0px",
    },
  },

  quickLinksContainer: {
    display: "flex",
    gap: "5px",
    flexDirection: "column",
  },

  quickLinksContainerTwo: {
    display: "flex",
    gap: "5px",
    flexDirection: "column",
  },

  quickLinksSubContainer: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
  },

  quickLinksSubContainerTwo: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
  },

  quickLinks: {
    color: "#FFFFFF",
    fontFamily: "Roboto",
    fontWeight: "500",
    fontSize: "16px",
    lineHeight: "17.6px",
    letterSpacing: "0%",
  },
  quickLinksOne: {
    color: "#FFFFFF",
    fontFamily: "Roboto",
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "17.6px",
    letterSpacing: "0%",
  },
  quickLinksTwo: {
    color: "#FFFFFF",
    fontFamily: "Roboto",
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "17.6px",
    letterSpacing: "0%",
  },
  quickLinksThree: {
    color: "#FFFFFF",
    fontFamily: "Roboto",
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "17.6px",
    letterSpacing: "0%",
    marginTop: "-10px",
  },
  roomOutlineContainer: {
    marginTop: "-15px",
  },
  copyRightFooter: {
    fontFamily: "Roboto",
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "22.4px",
    letterSpacing: "0 %",
    color: "#E2E8F0",
    textAlign: "center",
    marginBottom: "0px",
    paddingBottom: "30px",
  },
};
export default footerStyle;
